import React, { useState } from 'react';
import ExpandableSection from 'components/ExpandableSection/ExpandableSection';
import ReadOnlyWrapper from 'components/ReadOnlyWrapper/ReadOnlyWrapper';
import { ProFormaQuickStartValues } from 'views/public/ProFormaQuickStart/types';
import { ProFormaModelIds } from 'constants/proForma';
import ProFormaForecastTable from './ProFormaForecastTable/ProFormaForecastTable';
import ProFormaSaleProceeds from './ProFormaSaleProceeds/ProFormaSaleProceeds';
import ProFormaAssumptions from './ProFormaAssumptions/ProFormaAssumptions';
import ProFormaValuation from './ProFormaValuation/ProFormaValuation';
import { useProFormaSocketContext } from '../socketContext/ProFormaSocketProvider';
import { APARTMENT_CALCULATION_TYPE_NAME, NON_APARTMENT_CALCULATION_TYPE_NAME } from './constants';

export interface IProFormaDispositionProps {
    hasWriteAccessToProForma: boolean;
    signUpMode?: boolean;
    proFormaSignUpData?: ProFormaQuickStartValues;
}

const ProFormaDisposition = ({ hasWriteAccessToProForma, signUpMode, proFormaSignUpData }: IProFormaDispositionProps) => {
    const { proForma } = useProFormaSocketContext();

    const [selectedType, setSelectedType] = useState<string>(proForma?.proFormaModelId === ProFormaModelIds.APARTMENT
        ? APARTMENT_CALCULATION_TYPE_NAME.UNIT : NON_APARTMENT_CALCULATION_TYPE_NAME.GSF);

    return (
        <ReadOnlyWrapper isReadOnly={!hasWriteAccessToProForma}>
            <ExpandableSection
                number={1}
                title="Assumptions"
                subtitle="Assumptions about the sale of this investment"
                className="NSCard--level-2"
                isExpanded
                animate
            >
                <ProFormaAssumptions proFormaSignUpData={proFormaSignUpData} />
            </ExpandableSection>
            <ExpandableSection
                number={2}
                title="Forecast"
                subtitle="Estimate projections for this project on a trended and untrended basis"
                className="mt-3 NSCard--level-2"
                isExpanded
                animate
            >
                <ProFormaForecastTable />
            </ExpandableSection>
            <ExpandableSection
                number={3}
                title="Sale Proceeds"
                subtitle="Review the overview of proceeds at sale"
                className="mt-3 NSCard--level-2"
                isExpanded
                animate
            >
                <ProFormaSaleProceeds selectedType={selectedType} setSelectedType={setSelectedType} />
            </ExpandableSection>
            <ExpandableSection
                number={4}
                title="Valuation"
                subtitle="Review the forecasted valuation of this property"
                className="mt-3 NSCard--level-2"
                isExpanded
                animate
            >
                <ProFormaValuation selectedType={selectedType} setSelectedType={setSelectedType} />
            </ExpandableSection>
        </ReadOnlyWrapper>
    );
};

export default ProFormaDisposition;
